import React from 'react';
// import { Formik } from 'formik';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';

import OnboardingLayout from '../../components/layouts/OnboardingLayout';
import OnboardingLayoutBox from '../../components/layouts/OnboardingLayoutBox';
import SignUpTransactionsAmountForm from '../../components/forms/SignUpTransactionsAmountForm';
import { useHandleRegistrationFlowRedirect } from '../../hooks/registration';
// import StepIndicatorOnboarding from '../../components/common/StepIndicatorOnboarding/StepIndicatorOnboarding';

const Fallback = () => (
  <Box display="flex" justifyContent="center">
    <CircularProgress size={24} />
  </Box>
);

const SignUpTransactionsAmount = () => {
  const { t } = useTranslation();
  useHandleRegistrationFlowRedirect();

  return (
    <OnboardingLayout theme="dark">
      <OnboardingLayoutBox theme="dark">
        <Box mb="40px">
          {/* <StepIndicatorOnboarding currentStep={5} stepsCount={9} /> */}
          <h1>{t('How many transactions are you processing per month?')}</h1>
        </Box>
        <React.Suspense fallback={<Fallback />}>
          <SignUpTransactionsAmountForm />
        </React.Suspense>
      </OnboardingLayoutBox>
    </OnboardingLayout>
  );
};

export default SignUpTransactionsAmount;
